<template>
	<div ref="item" class="group-member-bar" :class="active ? 'active' : ''" :style="{ 'height': height + 'px' }">
		<div class="member-avatar">
			<head-image :size="headImageSize" :name="showNickName" :url="member.headImage"
				:id="member.userId" :online="member.online" :isGroupAdmin="isGroupAdmin" :isAddFriend="isAddFriend"
				:group-id="group.id" :member-muted="!!member.isMuted" :member-is-manager="!!member.isManager"
				:member-is-owner="member.userId == group.ownerId"> </head-image>
		</div>
		<div class="member-name" :style="{ 'line-height': height + 'px' }">
			<span class="member-name-text" :class="{ 'official-name': member.userTag == 1 }">{{ showNickName }}</span>
			<official-tag :user-tag="member.userTag" :user-tag-img="member.userTagImg"></official-tag>
			<el-tag class="tag" v-if="mine.id == member.userId" size="mini" type="primary">我</el-tag>
			<el-tag class="tag" v-if="member.userId == group.ownerId" size="mini" type="danger">群主</el-tag>
			<el-tag class="tag" v-if="member.isManager" size="mini" type="primary">管理员</el-tag>
			<el-tag class="tag" v-if="member.isMuted" size="mini" type="warning">禁言中</el-tag>
		</div>
		<slot></slot>
	</div>
</template>
<script>
import HeadImage from "../common/HeadImage.vue";
import OfficialTag from "../common/OfficialTag.vue";

export default {
	name: "groupMemberBar",
	components: { HeadImage, OfficialTag },
	data() {
		return {

		};
	},
	props: {
		group: {
			type: Object,
			required: true
		},
		member: {
			type: Object,
			required: true
		},
		height: {
			type: Number,
			default: 50
		},
		active: {
			type: Boolean,
			default: false
		},
		isGroupAdmin: {
			type: Boolean,
			default: false
		},
		isAddFriend: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		mine() {
			return this.$store.state.userStore.userInfo;
		},
		headImageSize() {
			return Math.ceil(this.height * 0.75)
		},
		showNickName() {
			const mRemarkName = this.member.showNickName;
			const groupRemarkName = this.member.remarkNickName || this.member.userNickName;
			if (mRemarkName == groupRemarkName || !groupRemarkName) {
				return mRemarkName;
			} else {
				return groupRemarkName + "(" + mRemarkName + ")";
			}
		},
	}
}
</script>


<style scoped lang="scss">
.group-member-bar {
	display: flex;
	position: relative;
	padding: 0 15px;
	align-items: center;
	white-space: nowrap;
	box-sizing: border-box;

	&:hover {
		background-color: var(--im-background-active);
	}

	&.active {
		background: #E1EAF7;
	}

	.head-image {
		flex-shrink: 0;
	}

	.member-name {
		display: flex;
		align-items: center;
		flex: 1;
		height: 100%;
		margin-left: 6px;
		gap: 4px;
		overflow: hidden;

		.member-name-text {
			text-align: left;
			font-size: var(--im-font-size);
			white-space: nowrap;
			overflow: hidden;
			min-width: 0;
			text-overflow: ellipsis;
		}

		.tag {
			margin-left: 3px;
			font-size: 10px;
			border-radius: 3px;
		}
	}
}
</style>